export default __webpack_public_path__ + "assets/facilitiesWide.09e90b7a.png";